import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuItem, MenuItemPath } from '@enums/menu-item.enum';

const routes: Routes = [
  {
    path: '',
    redirectTo: MenuItemPath.get(MenuItem.home),
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: MenuItemPath.get(MenuItem.home),
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
